import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { SetDataQualityTrigger } from '../AppActionTypes';

export interface SetDataQualityTriggerAction extends Action {
  item: IContentInfo;
}

export function setDataQualityTriggerAction(item: IContentInfo): SetDataQualityTriggerAction {
  return {
    type: SetDataQualityTrigger,
    item
  };
}
